import React from 'react'
import { Printer } from 'lucide-react'

const RefundInstallmentSlip = ({ installment, plotDetails, activeSociety }) => {
    if (!installment) return null

    const {
        amount = 0,
        paid_amount = 0,
        payment_date,
        status,
        installment_number
    } = installment

    const handlePrint = () => {
        const printWindow = window.open('', '_blank', 'width=800,height=600')

        const societyName = activeSociety?.name || 'Society Name'
        const societyLocation = activeSociety?.address || activeSociety?.city || 'Location'
        const customerName = plotDetails?.original_booking?.customer_id?.name || 'Customer'
        const plotNo = plotDetails?.plot_id?.plot_number || 'N/A'

        const formatCurrency = val => `PKR ${Number(val).toLocaleString('en-PK')}`
        const formatDate = val => val ? new Date(val).toLocaleDateString('en-GB') : 'N/A'

        const printContent = `
      <!DOCTYPE html>
      <html>
      <head>
        <title>Refund Installment Receipt - #${installment_number}</title>
         <style>
          @media print {
            @page { 
              size: A5 landscape; 
              margin: 8mm; 
            }
            body { margin: 0; }
            .no-print { display: none !important; }
          }
          body { 
            font-family: 'Segoe UI', 'Arial', sans-serif; 
            margin: 0; 
            padding: 20px; 
            background: white;
            font-size: 11px;
            color: #1f2937;
          }
           .header { 
            background: linear-gradient(135deg, #059669 0%, #10b981 100%); 
            color: white; 
            padding: 12px; 
            border-radius: 8px; 
            margin-bottom: 15px; 
            display: flex;
            justify-content: space-between;
          }
          .society-name { font-size: 16px; font-weight: 700; margin: 0; }
          .receipt-title { font-size: 12px; opacity: 0.9; text-transform: uppercase; font-weight: 600;}
          
          .info-grid {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 15px;
            margin-bottom: 20px;
          }
          
          .box {
            background: #f9fafb;
            border: 1px solid #e5e7eb;
            border-radius: 6px;
            padding: 10px;
          }
          
          .row {
            display: flex;
            justify-content: space-between;
            margin-bottom: 6px;
            font-size: 10px;
          }
          .label { color: #6b7280; font-weight: 500; }
          .val { color: #111827; font-weight: 700; }
          
          .amount-box {
            background: #ecfdf5;
            border: 1px solid #10b981;
            color: #065f46;
            text-align: center;
            padding: 15px;
            border-radius: 8px;
            margin-bottom: 20px;
          }
          .amount-label { font-size: 10px; text-transform: uppercase; letter-spacing: 1px; }
          .amount-val { font-size: 24px; font-weight: 800; margin-top: 5px; }
          
          .signatures {
            margin-top: 40px;
            display: flex;
            justify-content: space-between;
          }
          .sig-line {
            width: 150px;
            border-top: 1px solid #9ca3af;
            text-align: center;
            padding-top: 4px;
            font-size: 9px;
            color: #4b5563;
          }
          
          .print-btn {
            background: #10b981;
            color: white;
            border: none;
            padding: 8px 16px;
            border-radius: 4px;
            font-weight: 600;
            cursor: pointer;
            margin-top: 20px;
          }
         </style>
      </head>
      <body>
         <div class="header">
            <div>
              <h1 class="society-name">${societyName}</h1>
              <div style="font-size:10px; opacity:0.8;">${societyLocation}</div>
            </div>
            <div style="text-align:right;">
               <div class="receipt-title">Refund Payment Receipt</div>
               <div style="font-size:10px;">Date: ${formatDate(payment_date)}</div>
            </div>
         </div>
         
         <div class="info-grid">
             <div class="box">
                <div class="row">
                  <span class="label">Customer Name</span>
                  <span class="val">${customerName}</span>
                </div>
                <div class="row">
                  <span class="label">Plot Number</span>
                  <span class="val">${plotNo}</span>
                </div>
             </div>
             
             <div class="box">
                 <div class="row">
                  <span class="label">Installment No</span>
                  <span class="val">#${installment_number}</span>
                </div>
                <div class="row">
                  <span class="label">Payment Status</span>
                  <span class="val" style="color: ${status === 'Paid' ? '#059669' : '#d97706'}">${status}</span>
                </div>
             </div>
         </div>
         
         <div class="amount-box">
            <div class="amount-label">Amount Paid</div>
            <div class="amount-val">${formatCurrency(paid_amount || amount)}</div>
         </div>
         
         <div class="signatures">
            <div class="sig-line">Received By</div>
            <div class="sig-line">Authorized Signature</div>
         </div>
         
         <div style="text-align:center;">
            <button onclick="window.print()" class="print-btn no-print">Print Receipt</button>
         </div>
      </body>
      </html>
    `

        printWindow.document.write(printContent)
        printWindow.document.close()

        printWindow.onload = () => {
            printWindow.focus()
            printWindow.print()
        }
    }

    return (
        <button
            onClick={handlePrint}
            className='p-1.5 bg-emerald-100 hover:bg-emerald-200 text-emerald-700 rounded-lg transition-colors'
            title='Print Receipt'
        >
            <Printer className='w-4 h-4' />
        </button>
    )
}

export default RefundInstallmentSlip
